module.exports = __webpack_public_path__ + "img/public/SiteIcons/googleIcon.svg?0afbe389";